const truthyStrings = ['1', 'true', 'ok', 'yes'];

export function isTruthy(value: string | undefined): boolean {
  return value ? truthyStrings.includes(value.trim().toLowerCase()) : false;
}
